import { ElementAttribute } from "../../dom-tools/ElementAttribute";

export class SetBackgroundAttribute
{
  static readonly value = new ElementAttribute( "-set--background" );
}